module.exports = __webpack_public_path__ + "static/media/broker-step1.bc0e091c.png";